import React from 'react'
import { Badge } from '@planningcenter/tapestry-react'

export const DeprecatedBadge = props => {
  return (
    <Badge
      title="Deprecated"
      size="sm"
      color={{ foreground: '#fff', background: 'error' }}
      radius={4}
      {...props}
    />
  )
}

export const BetaBadge = props => {
  return (
    <Badge
      title="Beta"
      size="xs"
      color={{ foreground: '#fff', background: 'beta-pink' }}
      radius={4}
      fontWeight={500}
      style={{
        textDecoration: 'none',
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
      }}
      {...props}
    />
  )
}
